module.exports = "/fonts/fa-solid-900.ttf?f14c3b2ff7c821a4c838debbffd6ad2d";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-solid-900.ttf
// module id = XWAb
// module chunks = 0 1